document.addEventListener('DOMContentLoaded', () => {
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function getVariantIdFromUrl() {
    const url = new URL(window.location.href);
    return url.searchParams.get('variant');
  }

  function createSharedLightbox() {
    let lightbox = document.querySelector('[data-jg-lightbox]');

    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'jg-lightbox';
      lightbox.setAttribute('data-jg-lightbox', '');
      lightbox.hidden = true;

      lightbox.innerHTML = `
        <div class="jg-lightbox__backdrop" data-lightbox-close></div>

        <div class="jg-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Product image viewer">
          <button type="button" class="jg-lightbox__close" data-lightbox-close aria-label="Close image viewer">
            ×
          </button>

          <button type="button" class="jg-lightbox__arrow jg-lightbox__arrow--prev" data-lightbox-prev aria-label="Previous image">
            ‹
          </button>

          <div class="jg-lightbox__stage" data-lightbox-stage>
            <button type="button" class="jg-lightbox__zoom" data-lightbox-zoom aria-label="Zoom image">
              +
            </button>
            <img class="jg-lightbox__image" data-lightbox-image alt="">
          </div>

          <button type="button" class="jg-lightbox__arrow jg-lightbox__arrow--next" data-lightbox-next aria-label="Next image">
            ›
          </button>
        </div>
      `;

      document.body.appendChild(lightbox);
    }

    const imageEl = lightbox.querySelector('[data-lightbox-image]');
    const zoomBtn = lightbox.querySelector('[data-lightbox-zoom]');
    const prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    const nextBtn = lightbox.querySelector('[data-lightbox-next]');
    const closeEls = lightbox.querySelectorAll('[data-lightbox-close]');
    const dialogEl = lightbox.querySelector('.jg-lightbox__dialog');

    const state = {
      images: [],
      index: 0,
      zoomed: false
    };

    function render() {
      if (!state.images.length) return;

      const current = state.images[state.index];
      imageEl.src = current.src;
      imageEl.alt = current.alt || '';
      state.zoomed = false;
      lightbox.classList.remove('is-zoomed');
      zoomBtn.textContent = '+';
      zoomBtn.setAttribute('aria-label', 'Zoom image');

      prevBtn.hidden = state.images.length <= 1;
      nextBtn.hidden = state.images.length <= 1;
    }

    function open(images, startIndex = 0) {
      if (!images || !images.length) return;

      state.images = images;
      state.index = Math.max(0, Math.min(startIndex, images.length - 1));
      render();

      lightbox.hidden = false;
      document.body.classList.add('jg-lightbox-open');
    }

    function close() {
      lightbox.hidden = true;
      document.body.classList.remove('jg-lightbox-open');
      imageEl.removeAttribute('src');
      imageEl.removeAttribute('alt');
      lightbox.classList.remove('is-zoomed');
      state.zoomed = false;
    }

    function prev() {
      if (state.images.length <= 1) return;
      state.index = state.index === 0 ? state.images.length - 1 : state.index - 1;
      render();
    }

    function next() {
      if (state.images.length <= 1) return;
      state.index = state.index === state.images.length - 1 ? 0 : state.index + 1;
      render();
    }

    function toggleZoom() {
      state.zoomed = !state.zoomed;
      lightbox.classList.toggle('is-zoomed', state.zoomed);
      zoomBtn.textContent = state.zoomed ? '−' : '+';
      zoomBtn.setAttribute('aria-label', state.zoomed ? 'Zoom out image' : 'Zoom image');
    }

    closeEls.forEach((el) => {
      el.addEventListener('click', close);
    });

    lightbox.addEventListener('click', (event) => {
      if (lightbox.hidden) return;
      if (dialogEl && !dialogEl.contains(event.target)) {
        close();
      }
    });

    prevBtn.addEventListener('click', prev);
    nextBtn.addEventListener('click', next);
    zoomBtn.addEventListener('click', toggleZoom);
    imageEl.addEventListener('click', toggleZoom);

    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') prev();
      if (event.key === 'ArrowRight') next();
    });

    return { open, close };
  }

  const sharedLightbox = createSharedLightbox();
  const galleries = document.querySelectorAll('[data-jg-variant-gallery]');

  galleries.forEach((gallery) => {
    const jsonEl = gallery.querySelector('[data-variant-galleries]');
    if (!jsonEl) return;

    let variantGalleries = {};
    try {
      variantGalleries = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.warn('Variant gallery JSON parse error', e);
      return;
    }

    const mainEl = gallery.querySelector('[data-main]');
    const thumbsEl = gallery.querySelector('[data-thumbs]');
    const dotsEl = gallery.querySelector('[data-dots]');
    const upBtn = gallery.querySelector('[data-thumb-up]');
    const downBtn = gallery.querySelector('[data-thumb-down]');
    const sectionId = gallery.dataset.sectionId;
    const wrapper = gallery.closest('.jg-product-gallery-wrap');
    const defaultGallery = wrapper?.querySelector('[data-default-product-gallery]');
    const maxVisible = 4;

    let currentVariantId = gallery.dataset.selectedVariantId;
    let currentImages = [];
    let currentIndex = 0;
    let thumbStart = 0;
    let lastObservedVariantId = currentVariantId;

    function getVariantInput() {
      return (
        document.querySelector(`#product-form-${sectionId} input[name="id"]`) ||
        document.querySelector(`#product-form-installment-${sectionId} input[name="id"]`) ||
        wrapper?.closest('product-info')?.querySelector('input[name="id"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="id"]')
      );
    }

    function getCurrentVariantId() {
      const urlVariantId = getVariantIdFromUrl();
      if (urlVariantId) return String(urlVariantId);

      const input = getVariantInput();
      if (input?.value) return String(input.value);

      return String(currentVariantId || '');
    }

    function maybeSyncVariantGallery(source = 'unknown') {
      const nextVariantId = getCurrentVariantId();
      if (!nextVariantId) return;
      if (String(nextVariantId) === String(lastObservedVariantId)) return;

      lastObservedVariantId = String(nextVariantId);
      renderGalleryForVariant(nextVariantId);
    }

    function getDawnGalleryImages() {
      if (!defaultGallery) return [];

      const items = [...defaultGallery.querySelectorAll('.product__media-item')];

      return items
        .map((item) => {
          const img = item.querySelector('.product-media-container.media-type-image img');
          if (!img) return null;

          return {
            src: img.currentSrc || img.src,
            alt: img.getAttribute('alt') || '',
            mediaId: item.dataset.mediaId
          };
        })
        .filter(Boolean);
    }

    function syncMainSlider() {
      const slider = mainEl?.querySelector('[data-main-slider]');
      if (!slider) return;

      slider.style.transform = `translateX(-${currentIndex * 100}%)`;

      mainEl.querySelectorAll('[data-slide-index]').forEach((slide, index) => {
        slide.classList.toggle('is-active', index === currentIndex);
      });
    }

    function renderDots() {
      if (!dotsEl) return;

      if (currentImages.length <= 1) {
        dotsEl.innerHTML = '';
        return;
      }

      dotsEl.innerHTML = currentImages
        .map(
          (_, index) => `
            <button
              type="button"
              class="jg-variant-gallery__dot ${index === currentIndex ? 'is-active' : ''}"
              data-dot-index="${index}"
              aria-label="Go to image ${index + 1}"
            ></button>
          `
        )
        .join('');

      dotsEl.querySelectorAll('[data-dot-index]').forEach((btn) => {
        btn.addEventListener('click', () => {
          currentIndex = Number(btn.dataset.dotIndex);
          syncMainSlider();
          renderThumbs();
          renderDots();
        });
      });
    }

    function setupTouchSwipe() {
      const slider = mainEl?.querySelector('[data-main-slider]');
      if (!slider) return;

      let startX = 0;
      let endX = 0;

      slider.addEventListener(
        'touchstart',
        (e) => {
          startX = e.changedTouches[0].clientX;
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchend',
        (e) => {
          endX = e.changedTouches[0].clientX;
          const diff = startX - endX;

          if (Math.abs(diff) < 30) return;

          if (diff > 0) {
            currentIndex = currentIndex === currentImages.length - 1 ? 0 : currentIndex + 1;
          } else {
            currentIndex = currentIndex === 0 ? currentImages.length - 1 : currentIndex - 1;
          }

          syncMainSlider();
          renderThumbs();
          renderDots();
        },
        { passive: true }
      );
    }

    function renderMain() {
      if (!mainEl || !currentImages.length) return;

      mainEl.innerHTML = `
        <div class="jg-variant-gallery__main-slider" data-main-slider>
          ${currentImages
            .map(
              (image, index) => `
                <div class="jg-variant-gallery__slide ${index === currentIndex ? 'is-active' : ''}" data-slide-index="${index}">
                  <img
                    src="${image.src}"
                    alt="${image.alt || ''}"
                    class="jg-variant-gallery__main-image"
                    loading="${index === currentIndex ? 'eager' : 'lazy'}"
                    width="1200"
                    height="1200"
                  >
                </div>
              `
            )
            .join('')}
        </div>
      `;

      setupTouchSwipe();
      syncMainSlider();
    }

    function renderThumbs() {
      if (!thumbsEl) return;

      const visible = currentImages.slice(thumbStart, thumbStart + maxVisible);

      thumbsEl.innerHTML = visible
        .map((image, visibleIndex) => {
          const actualIndex = thumbStart + visibleIndex;
          return `
            <button
              type="button"
              class="jg-variant-gallery__thumb ${actualIndex === currentIndex ? 'is-active' : ''}"
              data-thumb-index="${actualIndex}"
              aria-label="Show image ${actualIndex + 1}"
            >
              <img src="${image.thumb}" alt="${image.alt || ''}" loading="lazy">
            </button>
          `;
        })
        .join('');

      if (upBtn) {
        upBtn.classList.toggle('hidden', thumbStart === 0 || currentImages.length <= maxVisible);
      }

      if (downBtn) {
        downBtn.classList.toggle(
          'hidden',
          thumbStart + maxVisible >= currentImages.length || currentImages.length <= maxVisible
        );
      }

      thumbsEl.querySelectorAll('[data-thumb-index]').forEach((btn) => {
        btn.addEventListener('click', () => {
          currentIndex = Number(btn.dataset.thumbIndex);
          renderMain();
          renderThumbs();
          renderDots();
        });
      });
    }

    function renderGalleryForVariant(variantId) {
      const normalizedVariantId = String(variantId);
      const images = variantGalleries[normalizedVariantId] || [];

      currentVariantId = normalizedVariantId;
      lastObservedVariantId = normalizedVariantId;

      if (!images.length) {
        gallery.classList.add('hidden');
        defaultGallery?.classList.remove('hidden');
        return;
      }

      gallery.classList.remove('hidden');
      defaultGallery?.classList.add('hidden');

      currentImages = images;
      currentIndex = 0;
      thumbStart = 0;

      renderMain();
      renderThumbs();
      renderDots();
    }

    mainEl?.addEventListener('click', (event) => {
      const img = event.target.closest('.jg-variant-gallery__main-image');
      if (!img || !isDesktop()) return;

      sharedLightbox.open(currentImages, currentIndex);
    });

    upBtn?.addEventListener('click', () => {
      thumbStart = Math.max(0, thumbStart - 1);
      renderThumbs();
    });

    downBtn?.addEventListener('click', () => {
      if (thumbStart + maxVisible < currentImages.length) {
        thumbStart += 1;
        renderThumbs();
      }
    });

    function setGalleryImageByIndex(index) {
      if (!currentImages.length) return;

      const safeIndex = Math.max(0, Math.min(index, currentImages.length - 1));
      currentIndex = safeIndex;
      renderMain();
      renderThumbs();
      renderDots();
    }

    const EMBROIDERY_IMAGE_RULES = {
      'the-merrymaker': {
        byVariant: {
          '46231942856952': { byOptionIndex: { 0: 2 } },
          '46231942889720': { byOptionIndex: { 0: 3 } }
        }
      },

      'the-purist-script-jolly-logo': {
        byVariant: {
          '46352176120056': { byOptionIndex: { 0: 2 } },
          '46352176152824': { byOptionIndex: { 0: 2 } },
          '46352176185592': { byOptionIndex: { 0: 2 } }
        }
      },

      'the-purist-vintage': {
        byVariant: {
          '47949747814648': { byOptionIndex: { 0: 2, 1: 3 } },
          '47949747421432': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907897377016': { byOptionIndex: { 0: 2 } },
          '47907900555512': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907896983800': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907894657272': { byOptionIndex: { 0: 2 } }
        }
      },

      'the-purist-field': {
        byVariant: {
          '47907906388216': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907906322680': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907905634552': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907905306872': { byOptionIndex: { 0: 2, 1: 3 } }
        }
      },

      'the-pilgrim-vintage': {
        byVariant: {
          '47948902760696': { byOptionIndex: { 0: 2, 1: 3 } },
          '47948907970808': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907920937208': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907921002744': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907920904440': { byOptionIndex: { 0: 2 } },
          '47907920969976': { byOptionIndex: { 0: 2 } }
        }
      },

      'the-pilgrim-field': {
        byVariant: {
          '47907906650360': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907906617592': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907906683128': { byOptionIndex: { 0: 2, 1: 3 } },
          '47907906584824': { byOptionIndex: { 0: 2, 1: 3 } }
        }
      }
    };

    function getProductHandle() {
      const parts = window.location.pathname.split('/products/');
      return parts[1] ? parts[1].split('/')[0] : '';
    }

    function maybeSyncEmbroideryImage(embroideryInput) {
      if (!embroideryInput || !embroideryInput.checked) return;

      const productHandle = getProductHandle();
      const variantId = String(getCurrentVariantId() || '');
      const productRules = EMBROIDERY_IMAGE_RULES[productHandle];
      const variantRules = productRules?.byVariant?.[variantId];

      if (!variantRules) return;

      const wrapper = embroideryInput.closest('.selector-wrapper');
      if (!wrapper) return;

      const groupInputs = [...wrapper.querySelectorAll('.bcpo-front-color-option')];
      const selectedIndex = groupInputs.findIndex((input) => input === embroideryInput);

      if (selectedIndex < 0) return;

      const imageIndex = variantRules.byOptionIndex?.[selectedIndex];

      if (typeof imageIndex === 'number') {
        setGalleryImageByIndex(imageIndex);
      }
    }

    document.addEventListener('change', (event) => {
      const embroideryInput = event.target.closest('.bcpo-front-color-option');
      if (!embroideryInput) return;

      maybeSyncEmbroideryImage(embroideryInput);
    });

    defaultGallery?.addEventListener(
      'click',
      (event) => {
        if (!isDesktop()) return;

        const trigger = event.target.closest('.product__modal-opener, .product__media-toggle');
        if (!trigger) return;

        const mediaItem = trigger.closest('.product__media-item');
        if (!mediaItem) return;

        const images = getDawnGalleryImages();
        if (!images.length) return;

        const startIndex = images.findIndex((item) => item.mediaId === mediaItem.dataset.mediaId);
        if (startIndex < 0) return;

        event.preventDefault();
        event.stopPropagation();

        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        sharedLightbox.open(images, startIndex);
      },
      true
    );

    document.addEventListener('change', (event) => {
      const input = event.target.closest('input[name="id"], select[name="id"]');
      if (!input) return;
      maybeSyncVariantGallery('change');
    });

    document.addEventListener('variant:change', (event) => {
      const variant = event.detail?.variant;
      if (!variant?.id) return;
      renderGalleryForVariant(variant.id);
    });

    const variantInput = getVariantInput();
    if (variantInput) {
      variantInput.addEventListener('input', () => maybeSyncVariantGallery('input'));
      variantInput.addEventListener('change', () => maybeSyncVariantGallery('input-change'));

      const observer = new MutationObserver(() => {
        maybeSyncVariantGallery('mutation');
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    window.addEventListener('popstate', () => maybeSyncVariantGallery('popstate'));
    window.addEventListener('hashchange', () => maybeSyncVariantGallery('hashchange'));

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    if (!window.__jgVariantHistoryPatched) {
      history.pushState = function (...args) {
        const result = originalPushState.apply(this, args);
        window.dispatchEvent(new Event('jg:historychange'));
        return result;
      };

      history.replaceState = function (...args) {
        const result = originalReplaceState.apply(this, args);
        window.dispatchEvent(new Event('jg:historychange'));
        return result;
      };

      window.__jgVariantHistoryPatched = true;
    }

    window.addEventListener('jg:historychange', () => maybeSyncVariantGallery('historychange'));

    let pollCount = 0;
    const maxPolls = 1200; // ~10 min at 500ms
    const poller = window.setInterval(() => {
      pollCount += 1;
      maybeSyncVariantGallery('poll');

      if (pollCount >= maxPolls) {
        window.clearInterval(poller);
      }
    }, 500);

    renderGalleryForVariant(getCurrentVariantId());

    const checkedEmbroideryInput = document.querySelector('.bcpo-front-color-option:checked');
    if (checkedEmbroideryInput) {
      maybeSyncEmbroideryImage(checkedEmbroideryInput);
    }
  });
});